<template>
    <div class="">
        <div class="cards-grid">
            <div class="card" v-for="(item, index) in transformedItems" :key="index" :tag="item.city" :item="item">
                <a :href="item.url">
                    <h3>{{ item.title }}</h3>
                    <p>{{ item.description }}</p>
                </a>
            </div>
        </div>

        <div v-if="!lastPage" class="text--center mt-medium">
            <BaseButton
                modifier="medium"
                tag="button"
                @click="refineNext"
            >
                View more
            </BaseButton>
        </div>
    </div>
</template>
<script>
export default {
    name: 'AlgoliaProductsGrid',
    props: {
        items: {
            type: Array,
            default: () => []
        },
        refineNext: {
            type: Function
        },
        lastPage: {
            type: Boolean,
            required: true
        },
        fallbackImage: {
            type: String
        }
    },
    computed: {
        transformedItems() {
            return this.items.map((i) => {
                if (i.transformed) return i;

                const image = i.image[0] == '' ? this.fallbackImage : i.image[0];

                return {
                    image,
                    title: i.title,
                    description: i.productDescription,
                    url: i.uri,
                    transformed: true,
                    city: i.productLocations ? i.productLocations[0].city : null
                }
            });
        },
        truncatedTitle() {
            return this.item.title.length > 30 ? (this.item.title.slice(0, 30) + '...') : this.item.title;
        },
    }
};
</script>
<style lang="scss" scoped>
    .cards-grid {
        display: flex;
        flex-wrap: wrap;
    }
    .card {
        width: 50%;
        flex-grow: 0;
    }
</style>
